import { render, staticRenderFns } from "./VirtualContractForReportWidget.vue?vue&type=template&id=2296a698&scoped=true&"
import script from "./VirtualContractForReportWidget.vue?vue&type=script&lang=js&"
export * from "./VirtualContractForReportWidget.vue?vue&type=script&lang=js&"
import style0 from "./VirtualContractForReportWidget.vue?vue&type=style&index=0&id=2296a698&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2296a698",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2296a698')) {
      api.createRecord('2296a698', component.options)
    } else {
      api.reload('2296a698', component.options)
    }
    module.hot.accept("./VirtualContractForReportWidget.vue?vue&type=template&id=2296a698&scoped=true&", function () {
      api.rerender('2296a698', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Widgets/VirtualContractForReportWidget.vue"
export default component.exports